import { NOTES_MAX_LENGTH, validateNotes } from '@baex/shared';

/**
 * The notes rule lives in `@baex/shared` so the API and this UI can never drift.
 * Nothing here redeclares the limit or the message — this only adapts the shared
 * `ValidationResult` to the `string | undefined` shape the form fields take.
 */
export { NOTES_MAX_LENGTH };

export function notesError(value: string): string | undefined {
  const result = validateNotes(value);
  return result.ok ? undefined : result.reason;
}
